import { clsx } from 'clsx';
import type { PropsWithClassName } from 'types/react-props';
import styles from './CloseIcon.module.scss';
import Icon from './Icon';

type CloseIconProps = PropsWithClassName<{
  onClose: () => void;
  label?: string;
}>;

const CloseIcon = ({ onClose, label, className }: CloseIconProps) => (
  <button
    onClick={onClose}
    aria-label={label ?? 'schließen'}
    className={clsx(styles.closeIcon, className)}
    type="button"
  >
    <Icon name="close" size={20} />
  </button>
);

export default CloseIcon;
